import { useState, useCallback } from 'react';

/**
 * Custom hook for handling modal open/close state.
 *
 * @param {boolean} [initialState=false] - Initial open state
 *
 * @example
 * const {
 *   open,
 *   handleOpen,
 *   handleClose,
 *   toggleOpen,
 * } = useModalDisclosure();
 */
export default function useModalDisclosure(initialState = false) {
  const [open, setOpen] = useState(initialState);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const toggleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  return {
    open,
    handleOpen,
    handleClose,
    toggleOpen,
    setOpen,
  };
}
